import { t } from '../../engine/i18n/i18n';
import type {
  AttackIncomingPayload,
  AttackResultPayload,
  DefenceResultPayload,
  GameNotification,
  MarchCancelledPayload,
} from './notifications-api';

export type ToastKind = 'info' | 'success' | 'error';

/** Pure — one message + toast colour per notification kind. No DOM, trivially testable. */
export function formatNotification(n: GameNotification): { message: string; toastType: ToastKind } {
  switch (n.kind) {
    case 'ATTACK_INCOMING': {
      const p = n.payload as AttackIncomingPayload;
      return { message: t('notifications.attackIncoming', { colony: p.targetColonyName }), toastType: 'error' };
    }
    case 'ATTACK_RESULT': {
      const p = n.payload as AttackResultPayload;
      return p.attackerWins
        ? { message: t(p.captured ? 'notifications.victoryCaptured' : 'notifications.victory', { colony: p.defenderColonyName }), toastType: 'success' }
        : { message: t('notifications.defeated', { colony: p.defenderColonyName }), toastType: 'error' };
    }
    case 'DEFENCE_RESULT': {
      const p = n.payload as DefenceResultPayload;
      return p.attackerWins
        ? { message: t(p.colonyLost ? 'notifications.raidedLost' : 'notifications.raided', { attacker: p.attackerColonyName, defender: p.defenderColonyName }), toastType: 'error' }
        : { message: t('notifications.heldOff', { attacker: p.attackerColonyName }), toastType: 'success' };
    }
    case 'MARCH_CANCELLED': {
      const p = n.payload as MarchCancelledPayload;
      return { message: t(p.unitsReturned === 1 ? 'notifications.recalled.one' : 'notifications.recalled.other', { colony: p.defenderColonyName, units: p.unitsReturned }), toastType: 'info' };
    }
  }
}
